document.addEventListener("DOMContentLoaded", function () {
  const newsletterSubmitButton = document.querySelector(
    ".newsletter .newsletter-form__button"
  );
  const newsletterForm = document.querySelector(".newsletter #contact_form");
  

  if (newsletterSubmitButton) {
    newsletterSubmitButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the form from submitting immediately

      const newsletterEmail = newsletterForm.querySelector(
        '[name="contact[email]"]'
      ).value;
      const checkConsent = newsletterForm.querySelector("#consent").checked;

      const header_value = {
        isoLanguage: "EN",
        isoCountry: "IN",
        brandCode: "BH8702",
        campaignId: "PN002392",
        campaignDescription: "Always On",
        origin: "https://lovebeautyandplanet.in/",
        formType: "signUp",
        entity: "PRM2.6",
      };

      const x_api_key = "665fb793-eb8d-42ed-85e7-31981ee4ac1a";

      const consumerIdentity = {
        firstName: "N/A",
        lastName: "N/A",
      };

      const contactDetail = {
        email: newsletterEmail
      };

      const optInStatus = {
        legalAgeConsent: checkConsent,
        unileverEmailConsent: checkConsent,
        unileverSMSConsent: checkConsent,
      };

      const data_value = JSON.stringify({
        profile: {
          header: header_value,
          consumerIdentity,
          contactDetail,
          optInStatus,
        },
      });

      console.log("Request Payload:", data_value);
      const consentErrorElement = document.getElementById('error-msg-consent');
      
      if (checkConsent == true) {
        fetch("https://forms-sg.unileversolutions.com/v3", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": x_api_key,
          },
          body: data_value,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            console.log("Success:", data);
            // If the API call is successful, submit the form to Shopify
            newsletterForm.submit();
          })
          .catch((error) => {
            console.error("Error:", error);
            // alert("Failed to submit the form. Please try again.");
            // newsletterForm.submit();
          });
          consentErrorElement.style.display = 'none';
      }
      else {
        event.preventDefault();  
        consentErrorElement.style.display = 'block';
      }
    });
  }
});
